import { render } from "./ComponentConfirmDelete.vue?vue&type=template&id=4607e3b6&scoped=true"
import script from "./ComponentConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ComponentConfirmDelete.vue?vue&type=script&lang=js"

import "./ComponentConfirmDelete.vue?vue&type=style&index=0&id=4607e3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4607e3b6"]])

export default __exports__